var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M33.025 2.584a8.777 8.777 0 0112.413-.026l.002.002.065.065a8.775 8.775 0 01-.14 12.4l-.822.822-.003.002-28.17 28.17a1.5 1.5 0 01-.688.392l-13.81 3.542a1.5 1.5 0 01-1.825-1.826l3.54-13.81a1.5 1.5 0 01.39-.685l.002-.003m1.862 3.976l-2.259 8.812 8.82-2.262-6.56-6.55zm9.478 5.223l-8.155-8.14L33.211 6.64l8.147 8.147-26.04 26.04zM43.364 4.726a5.775 5.775 0 01.112 7.938l-8.14-8.141a5.778 5.778 0 017.985.16l.043.043z","key":0}),React.createElement("path",{"d":"M3.98 31.628a.883.883 0 01.003-.003l29.042-29.04","key":1})]);
}

Edit.defaultProps = {"viewBox":"0 0 49 48"};

module.exports = Edit;

Edit.default = Edit;
